// extracted by mini-css-extract-plugin
export default {"inputContainer":"RadioButton_inputContainer__Xtxnl","customRadio":"RadioButton_customRadio__kExvw"};